/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResentNotificationResponseDto
 */
export interface ResentNotificationResponseDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof ResentNotificationResponseDto
     */
    workflowInstanceId?: string;
    /**
     * User Id
     * @type {string}
     * @memberof ResentNotificationResponseDto
     */
    userId?: string;
}

/**
 * Check if a given object implements the ResentNotificationResponseDto interface.
 */
export function instanceOfResentNotificationResponseDto(value: object): boolean {
    return true;
}

export function ResentNotificationResponseDtoFromJSON(json: any): ResentNotificationResponseDto {
    return ResentNotificationResponseDtoFromJSONTyped(json, false);
}

export function ResentNotificationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResentNotificationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function ResentNotificationResponseDtoToJSON(value?: ResentNotificationResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'userId': value['userId'],
    };
}

